module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1028-6cbdc0760ec424f0b4a34c7fd0cf8df9.png";